import { NgxMonacoEditorConfig } from "ngx-monaco-editor-v2";

export const monacoConfig: NgxMonacoEditorConfig = {
   onMonacoLoad: () => {
       (window as any).monaco.editor.defineTheme('ats-light', customThemeLight);
       (window as any).monaco.editor.defineTheme('ats-dark', customThemeDark);
   }
};

export const customThemeLight = {
   base: 'vs',
   inherit: false,
   rules: [
       { token: '', foreground: '2A2C2D' },
       { token: 'string.key.json', foreground: '7b3814' },
       { token: 'string.value.json', foreground: '0F6980', fontStyle: 'bold' }
   ],
   colors: {
       'editor.background': '#EFF3F8',
       'editor.lineHighlightBackground': '#E8E8E8',
       'editorCursor.foreground': '#0F6980',
       'editor.selectionBackground': '#D1E8F5',
       'editor.inactiveSelectionBackground': '#E5EEF5',
   }
};
export const customThemeDark = {
   base: 'vs-dark',
   inherit: false,
   rules: [
       { token: '', foreground: 'b5cea8' },
       { token: 'string.key.json', foreground: '9cdcfe' },
       { token: 'string.value.json', foreground: 'ce9178', fontStyle: 'bold' }
   ],
   colors: {
       'editor.background': '#42425f',
       'editor.lineHighlightBackground': '#3A3A53',
       'editorCursor.foreground': '#0F6980',
       'editor.selectionBackground': '#333751',
       'editor.inactiveSelectionBackground': '#3A3A53',
   }
};